import { setAvailableOrganizations } from './AvailableOrganizations';
import { setCurrentUser, disposeCurrentUser } from './CurrentUser';
import { setErrors, disposeErrors } from './Errors';
import { setLastAccessedOrganization, disposeLastAccessedOrganization } from './LastAccessedOrganization';
import { default as setChartConstruct } from './setChartConstruct';
import { default as SIGNOUT } from './deleteToken';
import { default as CREATE_CREDENTIAL } from './createCredential';
import { default as CREATE_DATASOURCE } from './createDatasource';
import { availableOrganizationsVar, currentUserVar, chartConstructVar, errorsVar, lastAccessedOrganizationVar, } from '../../cache';
export var commands = {
    // AvailableOrganization
    setAvailableOrganizations: setAvailableOrganizations(availableOrganizationsVar),
    /* no need for now because every user has to belong to at least one organization
    disposeAvailableOrganizations: disposeAvailableOrganizations(availableOrganizationsVar),
    */
    // CurrentUser
    setCurrentUser: setCurrentUser(currentUserVar),
    disposeCurrentUser: disposeCurrentUser(currentUserVar),
    // Errros
    setErrors: setErrors(errorsVar),
    disposeErrors: disposeErrors(errorsVar),
    // LastAccessedOrganization
    setLastAccessedOrganization: setLastAccessedOrganization(lastAccessedOrganizationVar),
    disposeLastAccessedOrganization: disposeLastAccessedOrganization(lastAccessedOrganizationVar),
    // ChartConstruct (for Chart)
    setChartConstruct: setChartConstruct(chartConstructVar),
    // Documennts for REST APIs
    SIGNOUT: SIGNOUT,
    CREATE_CREDENTIAL: CREATE_CREDENTIAL,
    CREATE_DATASOURCE: CREATE_DATASOURCE,
};
